import { APP_JSON, BRANDING } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import isEmptyString from '../../helpers/is-empty-string';
import StaticIdSingletonClass from '../../helpers/static-id';
import CONFIG from '../../settings';
import { getErmEnabledCookieValues } from '../ssi-erm/ssi-erm-cookie-manager';

const API = {
  /**
   * @param {string} apikey
   * @param {string} branding
   * @param {string} sessionId
   * @returns {object} response object
   */
  recognize: ({ apikey, branding = BRANDING.SRC, sessionId }) => {
    const dfpSessionId = sessionId || CONFIG.application.defaults.dfpSessionId;
    let data;
    const ermEnabled = getErmEnabledCookieValues();
    if (ermEnabled) {
      data = ermEnabled.authRef;
    }
    const requestPayload = {
      data: {
        branding
      },
      function: 'LOGIN@RCG',
      grant_type: 'idproof_promise',
      promises: [
        {
          data,
          data_kind: 'ACTIVITY_REF',
          ref: 1,
          request_mode: isEmptyString(data) // if auth-ref doesn't exist in ermEnabled clientside cookie, activity_ref will come from cookie
            ? 'urn:ext:oauth:request-mode:cookie'
            : 'urn:ext:oauth:request-mode:body' // Enums:['urn:ext:oauth:request-mode:body', 'urn:ext:oauth:request-mode:cookie']
        }
      ],
      response_mode: [
        'urn:ext:oauth:response-mode:body', // for token
        'urn:ext:oauth:response-mode:cookie', // for secured_id_token
        'urn:ext:oauth:response-mode:cookie', // for activity_ref
        'urn:ext:oauth:response-mode:body' // for id_token,
      ],
      response_type: [
        'token',
        'urn:ext:oauth:response-type:activity_ref_ssi',
        'urn:ext:oauth:response-type:activity_ref',
        'urn:ext:ietf:params:oauth:response-type:id_token'
      ],
      software_statement_claimset: {
        oauth2_version: '1.0',
        oidc_version: '1.0',
        software_id: branding,
        software_version: '21.03', // TODO: determine if sdk version is ok, or if it needs to be checkout-widget version
        tenancy_context: {
          product_code: 'VXO'
        },
        uebas: [
          {
            ueba_id: dfpSessionId,
            ueba_source: 'THREAT_METRIX'
          }
        ]
      }
    };
    const headers = {
      Accept: APP_JSON,
      Authorization: `Basic ${btoa(apikey)}`,
      'Content-Type': APP_JSON,
      dfpSessionId
    };

    const options = {
      body: requestPayload,
      headers,
      method: 'POST',
      url: CONFIG.application.api.token.recognize(StaticIdSingletonClass.namespace)
    };

    return fetchReq(options);
  }
};

export default API;
